module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Right-circle-691b0f307d5a7012f4516be5f7053027.svg";